import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { usePostHog } from "posthog-js/react";

import { appleAuth, AppleAuthRequest } from "@/api";
import { initializePosthog } from "@/services";
import { PostHogEvent } from "@/shared/types";
import { useOnboardingStore } from "@/stores";
import { UserStatus } from "@/types";
import { CookiesService } from "@/utils";
import { useUIStore } from "stores/ui.store";

const useSignupWithApple = () => {
  const { replace } = useRouter();
  const posthog = usePostHog();

  const openToast = useUIStore((state) => state.actions.toast.openToast);
  const referralCode = useOnboardingStore((state) => state.referralCode);

  return useMutation({
    mutationFn: (body: AppleAuthRequest) => {
      return appleAuth({ ...body, affiliateCode: referralCode });
    },
    onSuccess: ({ tokens, user }) => {
      if (user.status !== UserStatus.NOT_ONBOARDED) {
        return openToast({ variant: "error", message: "Your can't sign up with this email" });
      }
      initializePosthog(posthog, user);
      posthog?.capture(PostHogEvent.SIGN_UP);

      CookiesService.setAccessToken(tokens.accessToken);
      CookiesService.setRefreshToken(tokens.refreshToken);
      CookiesService.setUserStatus(user.status);

      replace("/auth/onboarding");
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useSignupWithApple };
